





























import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { MAX_COLLAB_INVITES } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import UserSearchAndSelect from "@/components/UserSearchAndSelect";

export default defineComponent({
  name: "InviteCreatorsModal",
  components: { BaseButton, UserSearchAndSelect, BaseConfirm },
  props: {
    show: { type: Boolean, required: true },
    invitedUserIds: { type: Array as PropType<string[]>, default: () => [] },
  },
  setup(props, { emit }) {
    const loading = ref(false);
    const selectedUserIds = ref<string[]>([]);

    const maxInvitationCount = computed(() => MAX_COLLAB_INVITES - props.invitedUserIds.length);

    const onInvite = () => {
      loading.value = true;
      emit("invite", selectedUserIds.value, () => {
        loading.value = false;
        selectedUserIds.value = [];
      });
    };

    const onCancel = () => {
      emit("close");
      selectedUserIds.value = [];
    };

    return { loading, selectedUserIds, maxInvitationCount, onInvite, onCancel };
  },
});
